module.exports = __webpack_public_path__ + "img/leaf@2x.5b0de204.png";